import axios, { AxiosError, AxiosRequestConfig } from "axios"
import {
  requestInterceptorErrorSecurityCredentials,
  requestInterceptorSuccessCredentials,
  responseInterceptorErrorCredentials,
  responseInterceptorSuccessCredentials,
} from "interceptors"
import { FIELDS } from "lib/constants/fields"
import {
  IDENTIFICATION_PATH,
  LIST_PATH,
  SUPPLIER_FILE_PATH,
  SUPPLIER_PATH,
} from "../../constants/paths"

const instance = axios.create({
  baseURL: process.env.REACT_APP_CONFIGURATION_API_SERVICE_DOMAIN,
})
instance.interceptors.request.use(
  requestInterceptorSuccessCredentials,
  requestInterceptorErrorSecurityCredentials
)

instance.interceptors.response.use(
  responseInterceptorSuccessCredentials,
  responseInterceptorErrorCredentials
)
const formDataConfig: AxiosRequestConfig = {
  headers: {
    "Content-Type": "multipart/form-data",
  },
}

export const getSuppliersService = async () => {
  try {
    const result = await instance.get(SUPPLIER_PATH + LIST_PATH)
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}

export const getSupplierByIdService = async (id: any) => {
  try {
    const result = await instance.get(
      SUPPLIER_PATH + IDENTIFICATION_PATH + `/${id}`
    )
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}

export const createSupplierService = async (Supplier: any) => {
  try {
    const result = await instance.post(SUPPLIER_PATH, Supplier)
    return result.data
  } catch (error: any) {
    throw error as AxiosError
  }
}

export const deleteSupplierService = async (id: any) => {
  try {
    const result = await instance.delete(SUPPLIER_PATH + `/${id}`)
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}

export const editSupplierService = async (id: number, supplier: any) => {
  try {
    const result = await instance.put(SUPPLIER_PATH + `/${id}`, supplier)
    return result.data
  } catch (error: any) {
    throw error as AxiosError
  }
}

export const uploadSupplierFileService = async (
  id: number,
  tag: string,
  file: File
) => {
  const formData = new FormData()
  formData.append(FIELDS.supplierId.key, id.toString())
  formData.append(FIELDS.tag.key, tag)
  formData.append(FIELDS.file.key, file)
  try {
    const result = await instance.post(
      SUPPLIER_FILE_PATH,
      formData,
      formDataConfig
    )
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}

export const getSuppliersFileService = async (id: number) => {
  try {
    const result = await instance.get(SUPPLIER_FILE_PATH + LIST_PATH + `/${id}`)
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}

export const getSupplierFileByIdService = async (id: number) => {
  try {
    const result = await instance.get(SUPPLIER_FILE_PATH + `/${id}`, {
      responseType: "blob",
    })
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}

export const deleteSupplierFileByIdService = async (id: number) => {
  try {
    const result = await instance.delete(SUPPLIER_FILE_PATH + `/${id}`)
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}
